'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpanVisualization = require('./SpanVisualization');

var _SpanVisualization2 = _interopRequireDefault(_SpanVisualization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var d3 = require('d3');

/**
 * accepts a render function that will recieve:
 *   (spanData: object, svg: DOMElement, tooltip: DOMElement)
 * - creates those and positions, sizes them 
 */

var makeScopedD3Factory = function makeScopedD3Factory(renderLoop) {
  return (0, _SpanVisualization2.default)(function (spanData, redraw) {
    var getContainer = spanData.getContainer,
        question = spanData.question,
        data = spanData.data,
        min = spanData.min,
        height = spanData.height,
        width = spanData.width;


    var container = getContainer();
    var offset = container.getBoundingClientRect();

    var svg = d3.select(container).append('svg').attr('width', width).attr('height', height).style('position', 'absolute').style('left', Math.round(min.x - offset.left) + 'px').style('top', Math.round(min.y - offset.top) + 'px');

    var g = svg.append('g').attr('transform', 'translate(0,0)');

    var tooltipDiv = d3.select(container).append('div').attr('style', '\n        position: absolute; \n        left: ' + Math.round(min.x - offset.left) + 'px; \n        top:  ' + Math.round(min.y - offset.top) + 'px;\n      ');

    var tooltip = tooltipDiv.append('div').attr('style', '\n        position: absolute;\n      ').append('div').attr('class', 'd3-tooltip').attr('style', '\n        position: absolute;\n        text-align: center;\n        width: 90px;\n        padding: 4px;\n        font: 12px sans-serif;\n        background: #333;\n        color: white;\n        border: 0px;\n        pointer-events: none;\n        opacity: 0;\n      ');

    renderLoop({ spanData: spanData, svg: svg, g: g, tooltip: tooltip });
  });
};

exports.default = makeScopedD3Factory;


//////////////////
// WEBPACK FOOTER
// ./~/react-likert/lib/components/ScopedD3Base.js
// module id = 271
// module chunks = 168707334958949